import { useNavigate } from "react-router-dom";

/* CSS */
import styles from "./style/statDetails.module.css";

const DaysTraveledDetail = ({ rows, total }) => {

    // Filter to trips actually traveled
    const traveled = (rows || []).filter(r => r.days > 0);
    const navigate = useNavigate();

    if (!traveled.length) {
        return (
            <div className={styles.empty}>
                No trips traveled yet
            </div>
        )
    }

    return (
        <div className={styles.list}>
            {traveled.map((trip) => (
                <div key={trip.id} className={styles.dayRow}>
                    <button
                        type="button"
                        className={styles.tripBox}
                        onClick={() => navigate(`/trip/${trip.id}`)}
                        aria-label={`Open ${trip.title}`}
                    >
                        <div className={styles.rowTitle}>{trip.title}</div>
                        <div className={styles.rowSub}>{trip.rangeLabel}</div>
                    </button>
                    <div className={styles.dayCount}>
                        {`${trip.days} ${trip.days === 1 ? 'day' : 'days'}`}
                        {trip.ongoing && <span className={styles.ongoing}> (ongoing trip)</span>}
                    </div>
                </div>
            ))}

            <div className={styles.totalRow}>
                <span>Total: </span>
                <span className={styles.totalValue}>{`${total} ${total === 1 ? 'day' : 'days'}`}</span>
            </div>
        </div>
    );
};

export default DaysTraveledDetail;